/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
// import AUAmountComponent from '@aarhus-university/au-lib-react-components/build/amount';
import { getFromSessionStorage } from '@aarhus-university/au-lib-react-components/src/lib/helpers';
import FilterListComponent from './FilterListComponent';
import FilterListItemComponent from './FilterListItemComponent';
import EmptyComponent from './EmptyComponent';
import labels from '../i18n';

const emptyFilter = {
  mode: '',
  location: null,
  hours: null,
  area: 0,
};

const filterDelay = 100;

class FilterComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filter: emptyFilter,
      showModes: false,
      showHours: false,
      showLocations: false,
      showAreas: false,
      checkedForSession: false,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { sessionValid } = nextProps;
    const { checkedForSession } = prevState;
    // Eventuelt session-filter skal kun tjekkes for én gang
    if (sessionValid && !checkedForSession) {
      const sessionFilter = getFromSessionStorage(`${window.vacancyElement}-${window.vacancyLang}-vacancies-filter`);
      if (sessionFilter != null) {
        return {
          filter: sessionFilter,
          checkedForSession: true,
        };
      }
    }
    return null;
  }

  render() {
    const {
      filter,
      showHours,
      showLocations,
      showAreas,
      showModes,
    } = this.state;
    const {
      lang,
      empty,
      amount,
      hours,
      locations,
      areas,
      title,
      phdLink,
      mode,
      setFilter,
    } = this.props;

    if (empty) {
      return (
        <EmptyComponent
          lang={lang}
          title={title}
          mode={mode}
          phdLink={phdLink}
        />
      );
    }

    const renderLocations = locations.map(
      (l) => (
        <li key={l.value}>
          <FilterListItemComponent
            key={`${JSON.stringify(filter.location)}_${l.value}`}
            item={l}
            setSelected={(_location) => {
              filter.location = _location;
              this.setState({
                filter,
                showLocations: false,
              }, () => {
                setFilter(filter);
              });
            }}
          >
            {[
              <span key={0}>{l.label}</span>,
            ]}

          </FilterListItemComponent>
        </li>
      ),
    );
    const renderHours = hours.map(
      (h) => (
        <li key={h.value}>
          <FilterListItemComponent
            key={`${JSON.stringify(filter.hours)}_${h.value}`}
            item={h}
            setSelected={(_hours) => {
              filter.hours = _hours;
              this.setState({
                filter,
                showHours: false,
              }, () => {
                setFilter(filter);
              });
            }}
          >
            {[
              <span key={0}>{h.label}</span>,
            ]}
          </FilterListItemComponent>
        </li>
      ),
    );
    const renderAreas = areas.map(
      (a) => (
        <li key={a.value} className="area">
          <FilterListItemComponent
            key={`${JSON.stringify(filter.area)}_${a.value}`}
            item={a}
            setSelected={(_area) => {
              filter.area = _area;
              this.setState({
                filter,
                showAreas: false,
              }, () => {
                setFilter(filter);
              });
            }}
          >
            {[
              <span key={0}>{a.label}</span>,
              <br key={1} />,
              <span key={2}>{a.topics}</span>,
            ]}
          </FilterListItemComponent>
        </li>
      ),
    );

    const vipTapButtons = [
      <button
        type="button"
        className={`vip filter${filter.mode === 'vip' ? ' selected' : ''}`}
        onClick={() => {
          const prevMode = filter.mode;
          const newMode = prevMode === '' || prevMode === 'tap' ? 'vip' : '';
          filter.mode = newMode;
          this.setState({
            filter,
          }, () => {
            setTimeout(() => {
              this.setState({
                showModes: false,
              }, () => {
                setFilter(filter);
              });
            }, showModes ? filterDelay : 0);
            // Vi indsætter forsinkelse, hvis knappen er trykket på fra mobilt overlay
          });
        }}
      >
        <strong>{labels[lang].filterButtons.vip}</strong>
      </button>,
      <button
        type="button"
        className={`tap filter${filter.mode === 'tap' ? ' selected' : ''}`}
        onClick={() => {
          const prevMode = filter.mode;
          const newMode = prevMode === '' || prevMode === 'vip' ? 'tap' : '';
          filter.mode = newMode;
          filter.area = 0;
          this.setState({
            filter,
            showAreas: false,
          }, () => {
            setTimeout(() => {
              this.setState({
                showModes: false,
              }, () => {
                setFilter(filter);
              });
            }, showModes ? filterDelay : 0);
            // Vi indsætter forsinkelse, hvis knappen er trykket på fra mobilt overlay
          });
        }}
      >
        <strong>{labels[lang].filterButtons.tap}</strong>
      </button>,
    ];

    const phdButton = <a className="button phd small bg-staff" href={phdLink}>{labels[lang].filterButtons.phd}</a>;

    const renderVipTapPhdButtons = [...vipTapButtons, ...[phdButton]].map((v, i) => {
      const key = i;
      return (
        <li key={key}>
          {v}
        </li>
      );
    });

    const locationBtnText = filter.location === null
      ? labels[lang].filterButtons.location : filter.location.label;
    const hoursBtnText = filter.hours === null
      ? labels[lang].filterButtons.hours : filter.hours.label;
    const areaBtnText = filter.area === 0
      ? labels[lang].filterButtons.area : filter.area.label;

    const filtering = !(filter.mode === ''
      && filter.location == null && filter.hours == null && filter.area === 0);

    let amountText = '';
    if (amount > 0) {
      amountText = `${amount} `;
    } else if (filtering) {
      amountText = `${labels[lang].none} `;
    }

    let headerText = `<strong>${amount === 1 ? labels[lang].availableSingle : labels[lang].available}</strong> <span class="avoid-wrap">${title === '' ? '' : ` ${labels[lang].on} `} ${title}</span>`;
    if (filtering) {
      headerText = `<strong>${amount === 1 ? labels[lang].availableSingle : labels[lang].available}</strong> <span class="avoid-wrap">${amount === 1 ? labels[lang].matchesSingle : labels[lang].matches}</span>`;
      if (amount === 0) {
        headerText = `<strong>${labels[lang].none}</strong> ${headerText}`;
      }
    }

    return (
      <div className="row">
        <div className="column large-12 medium-12 small-12">
          <div className="au-vacancy-filter-container">
            <h1>
              {(() => {
                if (amount > 0) {
                  return <span><strong>{amountText}</strong></span>;
                }
                return null;
              })()}
              <span dangerouslySetInnerHTML={{ __html: headerText }} />
            </h1>
            <div className="au-vacancy-vip-tap">
              <div>
                <button
                  type="button"
                  className={`filter${filter.mode === '' ? ' vip-tap' : ''}`}
                  onClick={() => {
                    this.setState({
                      showLocations: false,
                      showHours: false,
                      showAreas: false,
                      showModes: true,
                    });
                  }}
                >
                  <strong>{labels[lang].select.type}</strong>
                </button>
                {vipTapButtons}
              </div>
              {phdButton}
              <FilterListComponent
                mobile
                visible={showModes}
                headline={labels[lang].select.type}
                renderElements={renderVipTapPhdButtons}
                onClose={() => {
                  this.setState({
                    showModes: false,
                  });
                }}
              />
            </div>
            <div className="au-vacancy-filter">
              <span>{`${labels[lang].filter}:`}</span>
              {(() => {
                if (mode !== 'department') {
                  return (
                    <FilterListComponent
                      mobile
                      visible={showLocations}
                      headline={labels[lang].select.location}
                      renderElements={renderLocations}
                      onClose={() => {
                        this.setState({
                          showLocations: false,
                        });
                      }}
                    />
                  );
                }
                return null;
              })()}
              <FilterListComponent
                mobile
                visible={showHours}
                headline={labels[lang].select.hours}
                renderElements={renderHours}
                onClose={() => {
                  this.setState({
                    showHours: false,
                  });
                }}
              />
              <FilterListComponent
                mobile
                visible={showAreas}
                headline={labels[lang].select.area}
                renderElements={renderAreas}
                onClose={() => {
                  this.setState({
                    showAreas: false,
                  });
                }}
              />
              {(() => {
                if (mode !== 'department') {
                  return (
                    <div className="au-vacancy-filter-location">
                      <button
                        type="button"
                        className={`filter${filter.location !== null ? ' selected' : ''}`}
                        onClick={() => {
                          if (filter.location === null) {
                            this.setState({
                              showLocations: true,
                              showHours: false,
                              showAreas: false,
                              showModes: false,
                            });
                          } else {
                            filter.location = null;
                            this.setState({
                              filter,
                            }, () => {
                              setFilter(filter);
                            });
                          }
                        }}
                      >
                        <strong>{locationBtnText}</strong>
                      </button>
                      <FilterListComponent
                        visible={showLocations}
                        headline={labels[lang].select.location}
                        renderElements={renderLocations}
                        onClose={() => {
                          this.setState({
                            showLocations: false,
                          });
                        }}
                      />
                    </div>
                  );
                }
                return null;
              })()}
              <div className="au-vacancy-filter-hours">
                <button
                  type="button"
                  className={`filter${filter.hours !== null ? ' selected' : ''}`}
                  onClick={() => {
                    if (filter.hours === null) {
                      this.setState({
                        showLocations: false,
                        showHours: true,
                        showAreas: false,
                        showModes: false,
                      });
                    } else {
                      filter.hours = null;
                      this.setState({
                        filter,
                      }, () => {
                        setFilter(filter);
                      });
                    }
                  }}
                >
                  <strong>{hoursBtnText}</strong>
                </button>
                <FilterListComponent
                  visible={showHours}
                  headline={labels[lang].select.hours}
                  renderElements={renderHours}
                  onClose={() => {
                    this.setState({
                      showHours: false,
                    });
                  }}
                />
              </div>
              {(() => {
                if (filter.mode === 'vip' && mode === 'main') {
                  return (
                    <div className="au-vacancy-filter-areas">
                      <button
                        type="button"
                        className={`filter${filter.area !== 0 ? ' selected' : ''}`}
                        onClick={() => {
                          if (filter.area === 0) {
                            this.setState({
                              showLocations: false,
                              showHours: false,
                              showAreas: true,
                              showModes: false,
                            });
                          } else {
                            filter.area = 0;
                            this.setState({
                              filter,
                            }, () => {
                              setFilter(filter);
                            });
                          }
                        }}
                      >
                        <strong>{areaBtnText}</strong>
                      </button>
                      <FilterListComponent
                        visible={showAreas}
                        headline={labels[lang].select.area}
                        renderElements={renderAreas}
                        onClose={() => {
                          this.setState({
                            showAreas: false,
                          });
                        }}
                      />
                    </div>
                  );
                }
                return null;
              })()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FilterComponent.propTypes = {
  lang: PropTypes.string.isRequired,
  empty: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  areas: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  hours: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
  })).isRequired,
  title: PropTypes.string.isRequired,
  phdLink: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  setFilter: PropTypes.func.isRequired,
  sessionValid: PropTypes.bool.isRequired,
};

FilterComponent.displayName = 'FilterComponent';
export default FilterComponent;
